export const [
  CONFIGURATION_REQUEST,
  CONFIGURATION_SUCCESS,
  CONFIGURATION_ERROR,
  ACTIVATE_MAINTENANCE,
  DEACTIVATE_MAINTENANCE,
] = ["CONFIGURATION_REQUEST", "CONFIGURATION_SUCCESS", "CONFIGURATION_ERROR", "ACTIVATE_MAINTENANCE", "DEACTIVATE_MAINTENANCE"]
